import Image from 'next/image'

import { twMerge } from 'src/libs/tailwind-css'

import { LABEL_STYLES, LinkButton } from '../design-system'

interface AssetDownloadProps {
    title: string
    href: string
    thumbnail: StaticImageData
    className?: string
}

export function AssetDownload({ title, href, thumbnail, className }: AssetDownloadProps) {
    return (
        <article
            className={twMerge(
                'snap-center bg-white rounded-3xl p-3 grid gap-4 grid-cols-[auto,minmax(0,1fr),auto] items-center',
                className
            )}
            style={{
                boxShadow:
                    '0px 22px 48px rgba(0, 0, 0, 0.03), 0px 8.03036px 17.5208px rgba(0, 0, 0, 0.0206994), 0px 3.89859px 8.50602px rgba(0, 0, 0, 0.0166887), 0px 1.91116px 4.16981px rgba(0, 0, 0, 0.0133113), 0px 0.755676px 1.64875px rgba(0, 0, 0, 0.00930055)',
            }}
        >
            <div className="w-16">
                <Image src={thumbnail} alt={title} layout="responsive" sizes="4rem" />
            </div>
            <label className={twMerge(LABEL_STYLES, 'justify-start')}>{title}</label>
            <LinkButton href={href} target="_blank" arrowRight>
                Download
            </LinkButton>
        </article>
    )
}
